import { useContext } from "react";

import { SettingsContext } from "shared/SettingsProvider/index";

export const useSettings = () => useContext(SettingsContext);
